import { render, staticRenderFns } from "./ManageNoteAdminDeviceWidgetComponent.vue?vue&type=template&id=353257b2&"
import script from "./ManageNoteAdminDeviceWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ManageNoteAdminDeviceWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports